import { Component, Input, OnDestroy,  signal,  ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { TimezoneService } from 'app/shared/services/timezone/timezone.service';
import { ReplaySubject } from 'rxjs'; 
import { IHeaderResponsivenessOptions } from 'app/shared/models/header-display-options';

@Component({
    selector: 'app-timezone-switch',
    templateUrl: './timezone-switch.component.html',
    styleUrls: ['./timezone-switch.component.scss'],
    standalone: false
})
export class TimezoneSwitchComponent implements OnDestroy {

  @Input() headerResponsivenessOptions: IHeaderResponsivenessOptions;

  @ViewChild(NgbDropdown) dropdown: NgbDropdown;


  private unsubscriber: ReplaySubject<boolean> = new ReplaySubject();
  private hoverTimeout: any;

  constructor(public timezoneService: TimezoneService) {}


  public handleSelectedChanged(option): void {
    let valueToStore = option?.value;
    this.timezoneService.setSelectedTimezone((valueToStore), true);
  }


  public onMouseEnter(dropdown: NgbDropdown) {
    if (this.headerResponsivenessOptions.hideTimezoneSwitch && !this.timezoneService.isDisabled) {
      clearTimeout(this.hoverTimeout);
      dropdown.open();
    }
  }

  public onMouseLeave(dropdown: NgbDropdown) {
    if (this.headerResponsivenessOptions.hideTimezoneSwitch && !this.timezoneService.isDisabled) {
      this.hoverTimeout = setTimeout(() => {
        dropdown.close();
      }, 150);
    }
  }

  public onDropdownToggle($event) {
     if(this.headerResponsivenessOptions.hideTimezoneSwitch) {
      $event.stopPropagation();
     }
  }

  ngOnDestroy(): void {
    this.unsubscriber.next(true);
    this.unsubscriber.complete();
  }
}